export default[
    {
        id:'1',
        title:'Lignex',
        description:'La protezione del legno posto all’esterno. Prodotti vernicianti specifici e cicli di trattamento combinati adatti alle diverse esigenze di protezione del legno.',
        image:require('../../../assets/Lignex.jpeg'),

    },
    {
        id:'2',
        title:'Amotherm',
        description:'Sistemi integrati per la protezione passiva dal fuoco. Prodotti dedicati per le diverse superfici, in base alle differenti proprietà meccaniche e ai differenti comportamenti al fuoco.',
        image:require('../../../assets/Amotherm.jpeg'),

    },
    {
        id:'3',
        title:'Bessemer',
        description:'La protezione del legno posto all’esterno. Prodotti vernicianti specifici e cicli di trattamento combinati adatti alle diverse esigenze di protezione del legno.',
        image:require('../../../assets/Bessemer.jpeg'),

    },
    {
        id:'4',
        title:'Stufex',
        description:'La protezione del legno posto all’esterno. Prodotti vernicianti specifici e cicli di trattamento combinati adatti alle diverse esigenze di protezione del legno.',
        image:require('../../../assets/Stufex.jpeg'),

    },
];
// for(var i in cred){
//     if(email==cred[i].username && password==cred[i].pass){
//       navigation.navigate("dashboard", {
//         role:cred[i].role
//       });
//     }
//     else{
//       alert("please enter valid username or password");
//     }
//   }